import { MyProfileActions } from '../actions';
import { MyProfileFetchState } from '../my-profile-state';
import { createReducer, on } from '@ngrx/store';
import { UserRoles } from '../../../../SGRE-shared/constants/app-constant';
import { myProfileConstants } from '../../model/my-profile-model';

export const initialState: MyProfileFetchState = {
  loading: null,
  success: null,
  results: null,
  error: null
};

export const myProfileReducer = createReducer(
  initialState,
  on(MyProfileActions.fetchMyProfileSuccess, (state, { results }) => {
    return {
      ...state,
      loading: null,
      success: true,
      results,
      error: null
    };
  }),
  on(MyProfileActions.addNewEntity, (state, { legalEntity }) => ({
    ...state,
    loading: null,
    success: null,
    results: {
      ...state.results,
      legalEntities: [...state.results.legalEntities, legalEntity],
    },
    error: null
  })),
  on(MyProfileActions.storeEmailUpdate, (state, { email }) => {
    return {
      ...state,
      results: {
        ...state.results,
        user: {
          ...state.results.user,
          alternateEmail: email,
          emailChanged: email
        },
      },
    };
  }),
  on(MyProfileActions.updateLegalEntityState,
    (state, { updatedRowData, index }) => {
      const updatedLegalEntities = state.results.legalEntities.map(
        (entity, i) => (i === index ? { ...entity, ...updatedRowData } : entity)
      );
      return {
        ...state,
        results: {
          ...state.results,
          legalEntities: updatedLegalEntities,
        },
      };
    }
  ),
  on(MyProfileActions.onCancelResetSalesRepLegalEntities, (state) => {
    const filteredLegalEntities = state.results.legalEntities.filter(
      (entity) => !entity.newObj
    );
    return {
      ...state,
      results: {
        ...state.results,
        legalEntities: filteredLegalEntities,
      },
    };
  }),
  on(MyProfileActions.onCancelResetLegalEntities, (state) => {
    const updatedLegalEntities = state.results.legalEntities.map((entity) => {
      const mutableEntity = { ...entity }; // Create a mutable copy of the entity
      [UserRoles.REQUESTER, UserRoles.PURCHASER, myProfileConstants.CUSTOMER_ADMIN, myProfileConstants.SALES_REP].forEach(
        (role) => {
          if (mutableEntity[role] === true) {
            mutableEntity[role] = false;
          }
        }
      );
      return mutableEntity;
    });
    return {
      ...state,
      results: {
        ...state.results,
        legalEntities: updatedLegalEntities,
      },
    };
  }),
  on(MyProfileActions.clearMyProfileState,
    () => ({ ...initialState })
  )
);
